import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Input,
  InputGroup,
  InputGroupText,
  Alert,
  Spinner,
  Card,
  CardBody,
  Badge,
  Progress,
  Label, // Label eklendi
  FormGroup, // FormGroup eklendi
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";
import imageHeader from "../assets/ossaPictures/hakkimizdaHeader.jpeg";
import {
  FaInfoCircle,
  FaCalculator,
  FaTrash,
  FaPrint,
  FaWhatsapp,
} from "react-icons/fa";

const DegerKaybiHesaplama = () => {
  // State
  const [formData, setFormData] = useState({
    rayic: "",
    hasar: "",
    km: "",
    kaskoSirket: "",
    telefon: "",
  });
  // KVKK Onay State'i
  const [kvkkOnay, setKvkkOnay] = useState(false);
  
  const [uiSonuc, setUiSonuc] = useState("");
  const [lastSonuc, setLastSonuc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  // User & time
  const currentUser = "ARS Hukuk";
  const [currentDate, setCurrentDate] = useState(
    new Date().toLocaleString("tr-TR")
  );

  useEffect(() => {
    AOS.init();
    const t = setInterval(
      () => setCurrentDate(new Date().toLocaleString("tr-TR")),
      1000
    );
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');
    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png";
      if (imgElement) {
        imgElement.src = newImgSrc;
        imgElement.width = "32";
        imgElement.height = "32";
      }
    }
  }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleClearForm = () => {
    setFormData({ rayic: "", hasar: "", km: "", kaskoSirket: "", telefon: "" });
    setKvkkOnay(false); // Checkbox'ı sıfırla
    setUiSonuc("");
    setLastSonuc(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUiSonuc("");

    // KVKK KONTROLÜ
    if (!kvkkOnay) {
      setUiSonuc(
        <Alert color="warning" style={{ borderRadius: 8, marginBottom: 0 }}>
          <h5 className="alert-heading mb-1"><FaInfoCircle /> KVKK Onayı Gerekli</h5>
          <p className="mb-0">Hesaplama yapabilmek için lütfen KVKK Aydınlatma Metni'ni okuyup onaylayınız.</p>
        </Alert>
      );
      // Uyarıyı göstermek için aşağı kaydır
      setTimeout(() => {
        const el = document.getElementById("sonuc-container");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return; // İşlemi durdur
    }

    setLoading(true);

    // Ahmet Merkepci için params (telefon hariç)
    const params = new URLSearchParams();
    params.append("rayic", formData.rayic);
    params.append("hasar", formData.hasar);
    params.append("km", formData.km);
    params.append("Hesapla", "Hesapla");

    try {
      
      const myWorkerUrl = "https://deger-kaybi-proxy.ibrahimoncelerwork.workers.dev/";
      const targetUrl = "https://ahmetmerkepci.com/arac-deger-kaybi-hesaplama/";
      const proxyUrl = "https://corsproxy.io/?" + encodeURIComponent(targetUrl);
      // 1. Ahmet Merkepci'ye gönder
      const response = await fetch(
        myWorkerUrl,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params,
        }
      );

      const html = await response.text();
      const match = html.match(/Tahmini değer kaybı\s+([\d.,]+)\s*₺/);

      if (match) {
        const tahminiDeger = match[1];
        const normalized = tahminiDeger.replace(/\./g, "").replace(",", ".");
        const tahminiDegerSayi = Number.parseFloat(normalized);
        const minTutar = Math.round(tahminiDegerSayi * 0.8);
        const maxTutar = Math.round(tahminiDegerSayi * 1.1);

        const sonucObj = {
          tahminiDeger,
          tahminiDegerSayi,
          minTutar,
          maxTutar,
          formData: { ...formData },
          tarih: currentDate,
          kullanici: currentUser,
        };

        setLastSonuc(sonucObj);

        // 2. Kendi endpoint'inize tüm bilgileri gönder (telefon dahil)
        try {
          await fetch("https://your-api-endpoint.com/api/deger-kaybi", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              rayic: formData.rayic,
              hasar: formData.hasar,
              km: formData.km,
              kaskoSirket: formData.kaskoSirket,
              telefon: formData.telefon,
              tahminiDeger: tahminiDeger,
              minTutar: minTutar,
              maxTutar: maxTutar,
              tarih: currentDate,
              kvkkOnay: true // Veritabanına onayı da kaydedebilirsiniz
            }),
          });
        } catch (error) {
          console.error("Veri kaydedilemedi:", error);
          // Hata olsa bile kullanıcıya sonucu göster
        }

        setUiSonuc(
          <div className="result-container">
            <div style={{ padding: "24px 24px 16px", textAlign: "center" }}>
              <h4
                style={{
                  fontSize: "1.4rem",
                  fontWeight: 700,
                  color: "#123274",
                  marginBottom: "16px",
                  fontFamily: "Benguiat Regular",
                }}
              >
                DEĞER KAYBI HESAPLAMA SONUCU
              </h4>
              <Badge
                color="light"
                pill
                className="position-absolute top-0 end-0 mt-3 me-3"
                style={{ fontSize: "0.75rem" }}
              >
                {currentUser} | {currentDate}
              </Badge>
            </div>

            {/* Progress Bar */}
            <div style={{ padding: "0 24px 16px", marginBottom: "16px" }}>
              <Progress multi style={{ height: 25, borderRadius: 8 }}>
                <Progress bar color="danger" value="30">Minimum</Progress>
                <Progress bar color="warning" value="40">Tahmini</Progress>
                <Progress bar color="success" value="30">Maksimum</Progress>
              </Progress>
            </div>

            {/* Rakamlar */}
            <div style={{ backgroundColor: "#f8f9fa", padding: "24px", borderRadius: "0 0 12px 12px" }}>
              <Row className="g-3 g-md-4">
                <Col md={4}>
                  <div style={{ padding: "10px", textAlign: "center", borderRight: "1px solid #e9ecef" }}>
                    <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#6c757d" }}>MİNİMUM</div>
                    {/* minTutar 1.5 ile çarpıldı */}
                    <div style={{ fontSize: "1.5rem", fontWeight: 700, color: "#dc3545" }}>
                      {Math.round(minTutar * 1.5).toLocaleString("tr-TR")}₺
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div style={{ padding: "10px", textAlign: "center", borderRight: "1px solid #e9ecef" }}>
                    <div style={{ fontSize: "0.9rem", fontWeight: 600, color: "#6c757d" }}>TAHMİNİ</div>
                    {/* String olan 'tahminiDeger' yerine sayısal 'tahminiDegerSayi' kullanılarak çarpıldı */}
                    <div style={{ fontSize: "1.8rem", fontWeight: 700, color: "#fd7e14" }}>
                      {Math.round(tahminiDegerSayi * 1.5).toLocaleString("tr-TR")}₺
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <div style={{ padding: "10px", textAlign: "center" }}>
                    <div style={{ fontSize: "0.8rem", fontWeight: 600, color: "#6c757d" }}>MAKSİMUM</div>
                    {/* maxTutar 1.5 ile çarpıldı */}
                    <div style={{ fontSize: "1.5rem", fontWeight: 700, color: "#198754" }}>
                      {Math.round(maxTutar * 1.5).toLocaleString("tr-TR")}₺
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* BİLGİLENDİRME VE WHATSAPP YÖNLENDİRMESİ - YENİ EKLENEN KISIM */}
            <div style={{ padding: "20px 24px 0" }}>
              <Alert color="primary" style={{ backgroundColor: '#eef2ff', border: '1px solid #c7d2fe', color: '#123274', borderRadius: '8px' }}>
                <div className="d-flex align-items-start">
                  <FaInfoCircle size={24} style={{ minWidth: '24px', marginTop: '2px', marginRight: '12px' }} />
                  <div>
                    <strong>Sonuçlar Tahminidir!</strong> 
                    <p className="mb-2" style={{ fontSize: '0.95rem', marginTop: '4px' }}>
                      Hesaplanan tutar; aracın kaza geçmişi, değişen parçalar ve piyasa koşullarına göre değişkenlik gösterebilir. Hak kaybı yaşamamak ve <strong>net sonuç</strong> almak için uzmanlarımızla görüşebilirsiniz.
                    </p>
                  </div>
                </div>
              </Alert>
            </div>

            {/* Butonlar */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                padding: "0 24px 24px",
                flexWrap: "wrap",
              }}
            >
              <Button
                color="secondary"
                onClick={printResult}
                className="shadow-sm"
                style={{ padding: "12px 24px", fontWeight: 600, borderRadius: "8px" }}
              >
                <FaPrint className="me-2" /> YAZDIR
              </Button>

              {/* WHATSAPP BUTONU - Numaranızı güncelleyin */}
              <Button
                href="https://wa.me/905402770001?text=Merhaba,%20web%20sitenizden%20araç%20değer%20kaybı%20hesaplaması%20yaptım.%20Detaylı%20bilgi%20ve%20net%20hesaplama%20için%20destek%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                color="success"
                className="shadow-sm"
                style={{ 
                  padding: "12px 24px", 
                  fontWeight: 600, 
                  borderRadius: "8px", 
                  backgroundColor: '#25D366', 
                  borderColor: '#25D366' 
                }}
              >
                <FaWhatsapp className="me-2" size={18} /> WHATSAPP İLE DANIŞ
              </Button>
            </div>
          </div>
        );
      } else {
        setUiSonuc(
          <Alert
            color="warning"
            style={{ borderRadius: 8, marginBottom: 0 }}
          >
            Sonuç bulunamadı. Lütfen girdiğiniz değerleri kontrol ediniz.
          </Alert>
        );
      }
    } catch (error) {
      setUiSonuc(
        <Alert color="danger" style={{ borderRadius: 8, marginBottom: 0 }}>
          <h5 className="alert-heading mb-1">İşlem Hatası</h5>
          <p className="mb-0">{error.message}</p>
        </Alert>
      );
    }

    setLoading(false);

    setTimeout(() => {
      const el = document.getElementById("sonuc-container");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  };

  const printResult = () => {
    const kayit = lastSonuc;
    if (!kayit) return;
    const { minTutar, maxTutar, tahminiDeger, formData: fd } = kayit;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Değer Kaybı Raporu</title>
          <style>
            body { font-family: 'Segoe UI', Arial, sans-serif; margin: 40px; line-height: 1.6; color: #344767; }
            .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #123274; padding-bottom: 20px; color: #123274; }
            .logo-circle { width: 60px; height: 60px; border-radius: 50%; background: #123274; color: white; display: inline-flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; margin-bottom: 10px; }
            .header h2 { font-size: 26px; margin: 10px 0 5px; font-weight: 700; }
            .result { border: 1px solid #e0e0e0; border-radius: 10px; padding: 25px; margin-bottom: 30px; background-color: #f9f9f9; }
            .result-grid { display: flex; justify-content: space-between; margin-top: 20px; text-align: center; gap: 10px; }
            .result-item { flex: 1; padding: 15px; background-color: white; border-radius: 8px; border: 1px solid #dee2e6; }
            .result-label { font-size: 13px; color: #6c757d; font-weight: 700; text-transform: uppercase; margin-bottom: 5px; }
            .value { font-size: 20px; font-weight: bold; }
            .red { color: #dc3545; } .orange { color: #fd7e14; } .green { color: #198754; }
            
            /* YENİ EKLENEN UYARI KUTUSU STİLİ */
            .warning-box { background-color: #eef2ff; border: 1px solid #c7d2fe; color: #123274; padding: 15px; border-radius: 8px; margin-bottom: 30px; font-size: 14px; text-align: center; }
            .warning-title { font-weight: bold; margin-bottom: 5px; display: block; }
            
            table { width: 100%; border-collapse: collapse; margin-bottom: 30px; }
            th { padding: 12px; text-align: left; border-bottom: 2px solid #e0e0e0; background-color: #f8f9fa; width: 40%; font-size: 14px; }
            td { padding: 12px; border-bottom: 1px solid #e0e0e0; font-size: 14px; }
            .footer { margin-top: 40px; font-size: 11px; text-align: center; color: #999; border-top: 1px solid #eee; padding-top: 20px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-circle">A</div>
            <h2>ARAÇ DEĞER KAYBI RAPORU</h2>
            <p style="font-size: 14px; margin:0;">Tarih: ${currentDate}</p>
          </div>

          <div class="result">
            <h3 style="margin: 0 0 15px 0; font-size: 18px;">HESAPLAMA SONUCU</h3>
            <div class="result-grid">
              <div class="result-item">
                <div class="result-label">Minimum</div>
                <div class="value red">${Number(minTutar).toLocaleString("tr-TR")}₺</div>
              </div>
              <div class="result-item">
                <div class="result-label">Tahmini</div>
                <div class="value orange">${tahminiDeger}₺</div>
              </div>
              <div class="result-item">
                <div class="result-label">Maksimum</div>
                <div class="value green">${Number(maxTutar).toLocaleString("tr-TR")}₺</div>
              </div>
            </div>
          </div>

          <div class="warning-box">
            <span class="warning-title">⚠️ ÖNEMLİ BİLGİLENDİRME</span>
            Bu rapordaki tutarlar, girilen verilere dayalı yaklaşık değerlerdir. Aracın kaza geçmişi, değişen parçaların durumu ve güncel piyasa koşulları net tutarı değiştirebilir. 
            <br/><br/>
            <strong>En doğru hesaplama ve hak kaybı yaşamamak için ofisimizle iletişime geçmenizi öneririz.</strong>
          </div>

          <h3 style="font-size: 18px; border-bottom: 2px solid #eee; padding-bottom: 10px;">ARAÇ VE HASAR BİLGİLERİ</h3>
          <table>
            <tr><th>Rayiç Değer</th><td>${Number(fd.rayic || 0).toLocaleString("tr-TR")} TL</td></tr>
            <tr><th>Hasar Tutarı</th><td>${Number(fd.hasar || 0).toLocaleString("tr-TR")} TL</td></tr>
            <tr><th>Kilometre</th><td>${Number(fd.km || 0).toLocaleString("tr-TR")} km</td></tr>
            ${fd.kaskoSirket ? `<tr><th>Kasko Şirketi</th><td>${fd.kaskoSirket}</td></tr>` : ""}
            <tr><th>Telefon</th><td>${fd.telefon || "-"}</td></tr>
          </table>

          <div class="footer">
            <p>ARS Hukuk Bürosu © ${new Date().getFullYear()} | Bu belge resmi evrak niteliği taşımaz, bilgilendirme amaçlıdır.</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 300);
  };

  return (
    <>
      <Helmet>
        <title>DEĞER KAYBI HESAPLAMA | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Araç değer kaybı hesaplama - ARS HUKUK"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com/deger-kaybi"
        />
        <meta
          property="og:title"
          content="DEĞER KAYBI HESAPLAMA | ARS HUKUK"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Araç değer kaybı hesaplama - ARS HUKUK"
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com/deger-kaybi"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"deger-kaybi-hesaplama"} />
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <div>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div>
            <br />
            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>ARAÇ DEĞER KAYBI HESAPLAMA</b>
            </h2>
            <p
              className="text-center"
              style={{ maxWidth: "700px", margin: "16px auto 0" }}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Kaza sonrası aracınızın değer kaybını tahmini olarak hesaplayın
            </p>
            <br />
          </div>

          {/* Form Card */}
          <div
            className="card"
            style={{
              borderRadius: "12px",
              border: "none",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              marginBottom: "24px",
            }}
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <div
              style={{
                background: "#123274",
                padding: "16px 24px",
                color: "white",
              }}
            >
              <h4
                style={{
                  color: "white",
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCalculator style={{ marginRight: "12px", opacity: 0.9 }} />
                DEĞER KAYBI HESAPLAMA FORMU
              </h4>
            </div>
            <div style={{ padding: "32px" }}>
              <Alert color="info" className="mb-4">
                <FaInfoCircle className="me-2" />
                Zorunlu alanlar işaretlenmiştir. Adım adım ilerleyin ve{" "}
                <strong>Hesapla</strong> butonuna basın.
              </Alert>

              <form onSubmit={handleSubmit}>
                <Row className="g-3 g-md-4">
                  <Col md={6}>
                    <label
                      style={{
                        fontWeight: 600,
                        marginBottom: "6px",
                        fontSize: "0.95rem",
                        color: "#344767",
                      }}
                    >
                      Araç Rayiç Değeri (TL): <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputGroup>
                      <Input
                        type="number"
                        min="0"
                        step="1"
                        name="rayic"
                        value={formData.rayic}
                        onChange={handleChange}
                        placeholder="Örn: 250000"
                        required
                        style={{
                          padding: "1rem 1.25rem",
                          borderColor: "#e9ecef",
                          fontSize: "1rem",
                          borderRadius: "9999px 0 0 9999px",
                        }}
                      />
                      <InputGroupText
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderColor: "#e9ecef",
                          color: "#495057",
                          fontWeight: 600,
                          padding: "1rem 1rem",
                          borderRadius: "0 9999px 9999px 0",
                        }}
                      >
                        TL
                      </InputGroupText>
                    </InputGroup>
                    <small
                      style={{
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        marginTop: "8px",
                        display: "block",
                      }}
                    >
                      Aracınızın güncel piyasa değerini giriniz
                    </small>
                  </Col>

                  <Col md={6}>
                    <label
                      style={{
                        fontWeight: 600,
                        marginBottom: "6px",
                        fontSize: "0.95rem",
                        color: "#344767",
                      }}
                    >
                      Hasar Tutarı (TL): <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputGroup>
                      <Input
                        type="number"
                        min="0"
                        step="1"
                        name="hasar"
                        value={formData.hasar}
                        onChange={handleChange}
                        placeholder="Örn: 15000"
                        required
                        style={{
                          padding: "1rem 1.25rem",
                          borderColor: "#e9ecef",
                          fontSize: "1rem",
                          borderRadius: "9999px 0 0 9999px",
                        }}
                      />
                      <InputGroupText
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderColor: "#e9ecef",
                          color: "#495057",
                          fontWeight: 600,
                          padding: "1rem 1rem",
                          borderRadius: "0 9999px 9999px 0",
                        }}
                      >
                        TL
                      </InputGroupText>
                    </InputGroup>
                    <small
                      style={{
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        marginTop: "8px",
                        display: "block",
                      }}
                    >
                      Onarım masraflarının toplam tutarını giriniz
                    </small>
                  </Col>
                </Row>

                <Row className="g-3 g-md-4 mt-2">
                  <Col md={6}>
                    <label
                      style={{
                        fontWeight: 600,
                        marginBottom: "6px",
                        fontSize: "0.95rem",
                        color: "#344767",
                      }}
                    >
                      Kilometre: <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputGroup>
                      <Input
                        type="number"
                        min="0"
                        step="1"
                        name="km"
                        value={formData.km}
                        onChange={handleChange}
                        placeholder="Örn: 50000"
                        required
                        style={{
                          padding: "1rem 1.25rem",
                          borderColor: "#e9ecef",
                          fontSize: "1rem",
                          borderRadius: "9999px 0 0 9999px",
                        }}
                      />
                      <InputGroupText
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderColor: "#e9ecef",
                          color: "#495057",
                          fontWeight: 600,
                          padding: "1rem 1rem",
                          borderRadius: "0 9999px 9999px 0",
                        }}
                      >
                        km
                      </InputGroupText>
                    </InputGroup>
                    <small
                      style={{
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        marginTop: "8px",
                        display: "block",
                      }}
                    >
                      Aracın kaza anındaki kilometre değeri
                    </small>
                  </Col>

                  <Col md={6}>
                    <label
                      style={{
                        fontWeight: 600,
                        marginBottom: "6px",
                        fontSize: "0.95rem",
                        color: "#344767",
                      }}
                    >
                      Telefon Numarası: <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputGroup>
                      <Input
                        type="tel"
                        name="telefon"
                        value={formData.telefon}
                        onChange={handleChange}
                        placeholder="Örn: 0555 555 55 55"
                        required
                        pattern="[0-9]{10,11}"
                        style={{
                          padding: "1rem 1.25rem",
                          borderColor: "#e9ecef",
                          fontSize: "1rem",
                          borderRadius: "9999px",
                        }}
                      />
                    </InputGroup>
                    <small
                      style={{
                        fontSize: "0.85rem",
                        color: "#6c757d",
                        marginTop: "8px",
                        display: "block",
                      }}
                    >
                      Size ulaşabileceğimiz telefon numarası
                    </small>
                  </Col>
                </Row>

                <Row className="g-3 g-md-4 mt-2">
                  <Col md={12}>
                    <label
                      style={{
                        fontWeight: 600,
                        marginBottom: "6px",
                        fontSize: "0.95rem",
                        color: "#344767",
                      }}
                    >
                      Kasko Şirketi (Opsiyonel):
                    </label>
                    <Input
                      type="text"
                      name="kaskoSirket"
                      value={formData.kaskoSirket}
                      onChange={handleChange}
                      placeholder="Örn: Anadolu Sigorta"
                      style={{
                        padding: "1rem 1.25rem",
                        borderColor: "#e9ecef",
                        fontSize: "1rem",
                        borderRadius: "9999px",
                      }}
                    />
                  </Col>
                </Row>
{/* KVKK Onay Kutusu - DÜZELTİLMİŞ VERSİYON */}
                <Row className="mt-4">
                  <Col md={12}>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '5px' }}>
                      {/* Checkbox */}
                      <Input
                        type="checkbox"
                        id="kvkkOnay"
                        checked={kvkkOnay}
                        onChange={(e) => setKvkkOnay(e.target.checked)}
                        style={{
                          opacity: 1,            // Gizlemeyi iptal et
                          visibility: 'visible', // Görünür yap
                          position: 'relative',  // Kaymayı engelle
                          zIndex: 10,            // Üstte tut
                          width: '20px',         // Genişlik
                          height: '20px',        // Yükseklik
                          marginRight: '10px',   // Yazı ile mesafe
                          cursor: 'pointer',
                          appearance: 'auto',    // Tarayıcı varsayılan görünümünü zorla
                          WebkitAppearance: 'checkbox' // Safari/Chrome desteği
                        }}
                      />
                      
                      {/* Label ve Link */}
                      <Label 
                        htmlFor="kvkkOnay" 
                        style={{ 
                          fontSize: '0.9rem', 
                          color: '#344767', 
                          cursor: 'pointer',
                          marginBottom: 0,
                          userSelect: 'none'
                        }}
                      >
                        <span 
                          onClick={(e) => {
                            e.preventDefault(); // Checkbox işaretlenmesin, sadece modal açılsın
                            toggleModal(); 
                          }} 
                          style={{ 
                            fontWeight: '700', 
                            color: '#123274', 
                            textDecoration: 'underline' 
                          }}
                        >
                          KVKK Aydınlatma Metni
                        </span>'ni okudum, anladım ve kişisel verilerimin işlenmesini onaylıyorum.
                      </Label>
                    </div>
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    marginTop: "24px",
                    gap: "16px",
                  }}
                >
                  <Button
                    type="button"
                    onClick={handleClearForm}
                    size="lg"
                    style={{
                      backgroundColor: "white",
                      borderColor: "#6c757d",
                      color: "#6c757d",
                      padding: ".75rem 1.5rem",
                      fontWeight: 600,
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                    className="shadow-sm"
                  >
                    <FaTrash /> Formu Temizle
                  </Button>

                  <Button
                    type="submit"
                    size="lg"
                    disabled={loading}
                    style={{
                      backgroundColor: "#123274",
                      borderColor: "#123274",
                      padding: ".75rem 2rem",
                      fontWeight: 600,
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                    className="shadow"
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" /> Hesaplanıyor...
                      </>
                    ) : (
                      <>Değer Kaybını Hesapla</>
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>

          {/* Results */}
          <div id="sonuc-container">
            {uiSonuc && (
              <Card
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "none",
                  overflow: "hidden",
                  backgroundColor: "white",
                  marginBottom: "24px",
                }}
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <CardBody className="p-0">{uiSonuc}</CardBody>
              </Card>
            )}
          </div>
        </Container>
      </div>

      {/* KVKK Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg" centered>
        <ModalHeader toggle={toggleModal} style={{ color: '#123274' }}>
          KVKK Aydınlatma Metni
        </ModalHeader>
        <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto', fontSize: '0.9rem', lineHeight: '1.6' }}>
          <h5 className="font-weight-bold">KİŞİSEL VERİLERİN KORUNMASI HAKKINDA AYDINLATMA METNİ</h5>
          <p>
            ARS Hukuk Bürosu olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, 
            kişisel verilerinizin güvenliği hususuna azami hassasiyet göstermekteyiz. 
            Bu form aracılığıyla paylaştığınız; Telefon Numarası, Araç Bilgileri ve Hasar Bilgileri, 
            yalnızca araç değer kaybı hesaplamasının yapılması ve tarafınıza geri dönüş sağlanması amacıyla işlenmektedir.
          </p>
          <p>
            <strong>Veri İşleme Amacı:</strong><br/>
            İletilen bilgiler, uzman ekibimiz tarafından değer kaybı tazminatının tahmini hesaplanması ve 
            süreç hakkında tarafınıza bilgi verilmesi amacıyla kullanılacaktır.
          </p>
          <p>
            <strong>Veri Aktarımı:</strong><br/>
            Kişisel verileriniz, yasal zorunluluklar haricinde üçüncü kişilerle paylaşılmamaktadır.
          </p>
          <p>
            KVKK'nın 11. maddesi kapsamındaki haklarınızı kullanmak için hukuk büromuzla iletişime geçebilirsiniz.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Kapat
          </Button>
          <Button 
            color="primary" 
            style={{ backgroundColor: '#123274' }} 
            onClick={() => {
              setKvkkOnay(true); // Modaldan "Onaylıyorum" diyebilmek için
              toggleModal();
            }}
          >
            Okudum, Onaylıyorum
          </Button>
        </ModalFooter>
      </Modal>

      <Footer />

      <Footer />
    </>
  );
};

export default DegerKaybiHesaplama;